import React, { useContext, useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataRH } from '../../../data/modules/hr-header';
import { Paper } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import Title from '../../../components/Title';
import TimeTrackingService from '../../../services/TimeTrackingService';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import moment from 'moment';
import { DownloadOutlined } from "@mui/icons-material";
import { Button } from '@mui/material';
import { hasPrivilege } from '../../../utils/privilege';
import { userDetailContext } from '../../../App';

const TimeTrackingEtatHistory = () => {
  const contextData = useContext(userDetailContext);
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({
    date_debut: '',
    date_fin: '',
    demandeur: '',
  });
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const columns = [
    { field: 'date_begin', headerName: 'Date de debut', width: 200 },
    { field: 'date_end', headerName: 'Date de fin', width: 150 },
    { field: 'nom_prenom', headerName: 'Nom et prénoms', width: 250 },
    { field: 'excel_filepath', headerName: 'Version excel', width: 250, renderCell: (params) => (
            <Button
                icon={<DownloadOutlined />}
                onClick={() => downloadFile(params.value, 'excel')} color="info"
            >
               <DownloadOutlined style={{ color: "#1a5fa1" }} />
                Télécharger Excel
            </Button>
        ), },
    { field: 'pdf_filepath', headerName: 'Version pdf', width: 250, renderCell: (params) => (
            <Button
                icon={<DownloadOutlined />} color="info"
                onClick={() => downloadFile(params.value, 'pdf')}
            >
               <DownloadOutlined style={{ color: "#1a5fa1" }} />
                Télécharger PDF
            </Button>
        ), },
    { field: 'created_at', headerName: 'Date de création', width: 200 },
  ];

  const valueDateFormatter = (date) => {
  
      return `${moment(date).format('MM/DD/YYYY')}`;
    }

    const downloadFile = (filepath, fileType) => {
    const url = filepath;

    const link = document.createElement('a');
    link.href = url;
    link.download = filepath; 

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log(`File downloaded: ${filepath}`);  

};


  useEffect(() => {
    const fetchData = async () => {
      setOpenLoadingSimpleBackdrop(true);
      try {
        const response = await TimeTrackingService.getTimeTrackingEtatHistory(filters);
        console.log(response);
        if (response.status) {
          setRows(
            response.data.map((item, index) => ({
              ...item,
              id: index,
              date_begin: valueDateFormatter(item.date_begin),
              date_end: valueDateFormatter(item.date_end),
              created_at: valueDateFormatter(item.created_at),
            }))
          );
        }
       
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setOpenLoadingSimpleBackdrop(false);
      }
    };

    fetchData();
  }, []);
 
  return (
    <MainContainer {...headerDataRH}>
      {hasPrivilege(contextData.privileges, "timetracking_report") ? (
      <>
      <LoadingSimpleBackdrop open={openLoadingSimpleBackdrop} />
      <Paper  style={{ padding: '20px', margin: '20px' }} justifyContent="center" alignItems="center"> 
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title>Historique de generation des états de pointage</Title>
        </div>
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </div>
      </Paper>
      </>) :
      <Paper style={{ padding: '20px', margin: '20px' }}>
        <Title>Vous n'avez pas les privilèges nécessaires pour accéder à cette page.</Title>
      </Paper>
      }
    </MainContainer>
  );
}

export default TimeTrackingEtatHistory;

